import { ChooseDeliveryTimeView } from '../views/ChooseDeliveryTime/chooseDeliveryTime.view';
import { RouteType, type } from './Router';
import { Routes } from './types';

export const chooseDeliveryTimeRoutes: RouteType[] = [
  {
    id: 'edit-delivery-time',
    path: Routes.ChooseDeliveryTime,
    titleKey: 'pageTitles.whenCome',
    component: ChooseDeliveryTimeView,
    type: type.PUBLIC,
  },
];
